function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#F44812",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 72,
    style: {
      strokeDasharray: "480px, 480px",
      strokeDashoffset: 960
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle-colored",
    fill: "#F44812",
    cx: 77,
    cy: 77,
    r: 72,
    style: {
      strokeDasharray: "480px, 480px",
      strokeDashoffset: 960
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    stroke: "#fff",
    strokeWidth: 10,
    points: "43.5,77.8  112.2,77.8 ",
    style: {
      strokeDasharray: "100px, 100px",
      strokeDashoffset: 200
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b028d3b3.svg";
export { ForwardRef as ReactComponent };